<div class="content">
  <div class="activetest">
    <div class="activetest-item" *ngFor="let item of activeTestTypes">
      <div
        class="activetest-item-wrapper"
        [ngClass]="{'selected-activetest' : activeTestType.id === item.id}"
      >
        <div class="activetest-icon" *ngIf="item.iconType === 'image' ">
          <logo-widget
            [serviceUrl]="item.iconUrl"
            [defaultUrl]="item.iconUrl"
            [styleInfo]="'icon'"
          ></logo-widget>
        </div>
        <div class="activetest-icon" *ngIf="item.iconType === 'material' ">
          <i class="matIcon-color material-icons mdi" [ngClass]="item.iconUrl"></i>
        </div>
        <div class="activetest-item-content">
          <div class="label">{{item.name}}</div>
          <div class="description">{{item.description}}</div>
          <div class="btn-container">
            <div class="new_btn" (click)="selectActiveTestType(item)">
              <i class="mdi-plus mdi"></i> <a>NEW</a>
            </div>
            <div class="template_btn" (click)="template(item.type)">
              <i class="mdi mdi-text-box"></i><a>TEMPLATE</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
